import {host} from '@utils/hostConf';
import {get, post} from '@utils/baseRequest';
import {parseParams, handleParams} from '@utils/tools';

//获取即刻视频问诊列表
export async function queryDoctorsthList({
  page_no = 1,
  page_size = 10,
  is_front_page = 1,
  order = 1,
  doctor_name = '',
  city_no = '',
  dept_no = '',
  doctor_sign_extension = 2048,
}) {
  let params = parseParams(
    handleParams({
      page_no,
      page_size,
      is_front_page,
      order,
      doctor_sign_extension,
      doctor_name,
      city_no,
      dept_no,
    })
  );

  let res = await get({url: `${host.cplus}cgi-bin/user/querydoctorsthlist?${params}`})

  return {
    list: res.doctor_sth_list,
    page_no: res.current_page,
    page_size: res.doctor_sth_list_size,
    total_page: res.total_page,
  };
}

//获取医生列表新接口
export async function requestRcmDoc(data) {
  /*
  city_no	城市编码	number
  date	日期列表	number	例如：[20191025,20191026,20191027]
  dept_no	科室编码	number
  disease_id	疾病id	array<number>	例如：[1,2,3]
  doctor_id	医生id	number	当搜索医生时使用
  lat	纬度	string	例如：22.123
  lon	经度	string	例如：120.123
  number	号源	number	1：有号源 2：无号源
  page_no	页码	number	必填
  page_size	页面大小	number	必填
  price	价格列表	array<number>	例如：[1,2,3]
  shop_no	分院编码	number
  sort_type	排序类型	number	1:回诊率 2:距离 3:门诊量 4:好评率 5:最新出诊
  title	称号列表	array<number>	例如：[1,2,3]
  property   1:线下 2:视频
  */
  let postData = {
    page_no: 1,
    page_size: 10,
    ...data,
  };
  let res = await post({url: `${host.cplus}cgi-bin/search/doctorrecommendv2`, data: handleParams(postData)});
  return {
    list: res.doctor_list,
    page_no: res.current_page,
    page_size: res.doctor_list ? res.doctor_list.length : '10',
    total_page: res.total_page,
    total_num: res.total_num,
  };
}

// 城市列表
export function queryCityList() {
  return get({url: `${host.cplus}cgi-bin/mix/querycity`, data: {page_no: 1, page_size: 1000, query_type: 0}});
}

export async function getBanner(params) {
  params = parseParams(params);
  let res = await get({url: `${host.banner}Interface/getbanner?${params}`});
  return {list: res.data};
}

export const requestUserStepDetail = params => {
  return get({url: `${host.goapi}userstep/handler/QueryUserStepDetail`, data: {...params}});
};

export const requestRecipeProcess = params => {
  return get({url: `${host.goapi}userstep/handler/QueryRecipeProcess`, data: {...params}});
};
